import axios from '@/axios-service';
import snakeCaseKeys from 'snakecase-keys'; 
import { ResponseContent, responseContent } from "../types";
import { GenericMessage, ChangePasswordEmailDTO, ChangePasswordTokenDTO } from './types';


const MS_URL = 'uaa';
const MS_URL_PASSWORD = 'password-reset/users';
const responseGenericMessage= responseContent(GenericMessage);



// eslint-disable-next-line import/prefer-default-export
export const getUserDetails = () => axios.get(`${MS_URL}/users/me/`);

// needs to be authenticated
export const changePassword = async (changePasswordEmail: ChangePasswordEmailDTO): Promise<ResponseContent<GenericMessage>> => axios
  .post(`${MS_URL}/users/changePassword`, snakeCaseKeys(changePasswordEmail))
  .then(responseGenericMessage);

// doesn't need to be authenticated
export const resetPassword = async (userInfo: string): Promise<ResponseContent<GenericMessage>> => axios
.get(`${MS_URL_PASSWORD}/resetPassword`, {
  params: {
    userInfo
  }
})
.then(responseGenericMessage);

// doesn't need to be authenticated
export const savePassword = async (changePasswordToken: ChangePasswordTokenDTO): Promise<ResponseContent<GenericMessage>> => axios
.post(`${MS_URL_PASSWORD}/savePassword`, changePasswordToken)
.then(responseGenericMessage);


export const generateSecretKey = async (companyId: string): Promise<string> => axios
  .patch(`${MS_URL}/companies/${companyId}/client-secret`)
  .then(content => content.data)
